import script from "./BannerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerSection.vue?vue&type=script&setup=true&lang=js"

import "./BannerSection.vue?vue&type=style&index=0&id=65fffd3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fffd3e"]])

export default __exports__